const parse = require('./parse')
const clean = (version, options) => {
  const s = parse(version.trim().replace(/^[=v]+/, ''), options)
  return s ? s.version : null
}
module.exports = clean



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/clean.js
// module id = 1409
// module chunks = 0